import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import axios from "axios";
import { BASE_URL, HEADERS } from "../../../utils/constant";
import { toast } from "react-toastify";
import Select from "react-select";

import AddTagModal from "../../Modals/AddTagModel";
import { useCommonContext } from "../../../utils/context";
import { useTypeConfig } from "../../../utils/useTypeConfig";
import { useNavigate, useLocation } from "react-router-dom";

function GenerateTicketsModal({
  show,
  handleClose,
  ticket,
  fetchTickets,
  action,
  setTicketAction,
}) {
  const { labels, hiddenFields } = useTypeConfig();
  const [subCustomers, setSubCustomers] = useState({});

  const [brandNames, setBrandNames] = useState({});

  const [showAddTagModal, setShowAddTagModal] = useState(false);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [serviceData, setServiceData] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [selectedService, setSelectedService] = useState(null);

  const [selectedSubCustomer, setSelectedSubCustomer] = useState(null);

  const [selectedBrandName, setSelectedBrandName] = useState(null);

  const { fetchCustomers, customers } = useCommonContext();
  const { user } = useCommonContext();

  useEffect(() => {
    fetchService();
  }, []);

  useEffect(() => {
    fetchSubCustomersTec(selectedCustomer?.value);
    fetchCustomersProduct(selectedCustomer?.value);
  }, [showAddTagModal]);

  useEffect(() => {
    if (ticket) {
      if (ticket.customerDetails?.id) {
        fetchSubCustomersTec(ticket.customerDetails.id);
        fetchCustomersProduct(ticket.customerDetails.id);
      }
    }
  }, [ticket]);

  useEffect(() => {
    if (ticket) {
      reset({
        taskName: ticket.taskName || "",
        date: ticket.date || "",
        time: ticket.time || "",

        purpose: ticket.purpose || "",

        model: ticket.model || "",
      });

      setSelectedCustomer({
        value: ticket.customerDetails?.id,
        label:
          ticket.customerDetails?.customer_name +
          (ticket.customerDetails?.customer_tag
            ? ` - ${ticket.customerDetails.customer_tag}`
            : ""),
      });

      setSelectedService({
        value: ticket.serviceDetails?.id,
        label: ticket.serviceDetails?.service_name,
      });

      setSelectedSubCustomer({
        value: ticket.subCustomerDetails?.id,
        label: ticket.subCustomerDetails?.customer_name,
      });

      setSelectedBrandName({
        value: ticket.product_name?.id,
        label: ticket.product_name?.name,
      });
    } else {
      reset({});

      setSelectedCustomer(null);

      setSelectedService(null);

      setSelectedSubCustomer(null);

      setSelectedBrandName(null);
    }
  }, [show, ticket, reset]);

  const fetchService = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/services/?page_size=all`,
        {
          headers: {
            ...HEADERS,
          },
        },
      );
      setServiceData(response.data.results);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const fetchSubCustomersTec = async (customerId) => {
    if (!customerId) return;
    try {
      const { data } = await axios.get(
        `${BASE_URL}/users/tms_users/?role=subcustomer&customer_id=${customerId}&page_size=all`,
        { headers: HEADERS },
      );

      if (Array.isArray(data.results)) {
        setSubCustomers((prev) => ({
          ...prev,
          [customerId]: data.results,
        }));
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching subcustomers:", error);
    }
  };

  const fetchCustomersProduct = async (customerId) => {
    if (!customerId) return;
    try {
      const { data } = await axios.get(
        `${BASE_URL}/users/customer_brandnames/${customerId}`,
        { headers: HEADERS },
      );

      if (Array.isArray(data)) {
        setBrandNames((prev) => ({
          ...prev,
          [customerId]: data,
        }));
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  };

  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setSelectedCustomer(null);
      return;
    }

    setSelectedCustomer(selectedOption);
    fetchSubCustomersTec(selectedOption?.value);

    fetchCustomersProduct(selectedOption?.value);
  };

  const handleSubCustomerChange = (selectedOption) => {
    setSelectedSubCustomer(selectedOption);
  };

  const handleBrandNameChange = (selectedOption) => {
    setSelectedBrandName(selectedOption);
  };

  const handleFormSubmit = async (data) => {
    const payload = {
      taskName: data.taskName,
      date: data.date,
      time: data.time,

      model: data.model,
      purpose: data.purpose,
      customerDetails: selectedCustomer?.value || null,

      serviceDetails: selectedService?.value || null,

      subCustomerDetails: selectedSubCustomer?.value || null,

      product_name: selectedBrandName?.value,
    };

    let apiUrl;
    let apiMethod;

    if (action === "edit") {
      apiUrl = `${BASE_URL}/api/tickets/${ticket?.id}/`;
      apiMethod = axios.put;
    } else {
      apiUrl = `${BASE_URL}/api/tickets/`;
      apiMethod = axios.post;
    }

    try {
      setLoading(true);
      const response = await apiMethod(apiUrl, payload, { headers: HEADERS });
      if (response) {
        handleClose();

        toast.success(
          `${
            action === "edit"
              ? "Ticket updated"
              : action === "reassign"
                ? "Ticket reassigned"
                : "Ticket created"
          } successfully.`,
        );

        if (location.pathname !== "/dashboard/tickets") {
          navigate("/dashboard/tickets");
        } else {
          fetchTickets();
        }
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const serviceOptions = serviceData?.map((service) => ({
    value: service.id,
    label: service.service_name,
  }));

  const customerOptions = customers
    ?.filter((customer) => customer.is_active === true)
    .map((customer) => ({
      value: customer.id,
      label: `${customer.customer_name} ${
        customer.customer_tag ? `- ${customer.customer_tag}` : ""
      }`,
    }));

  const subcustomerOptions = subCustomers[selectedCustomer?.value]
    ?.filter((subCustomer) => subCustomer.is_active === true)
    .map((subCustomer) => ({
      value: subCustomer.id,
      label: subCustomer.customer_name || "None",
    }));

  const handleServiceChange = (selectedOption) => {
    setSelectedService(selectedOption);
  };

  const handleCloseWithReset = () => {
    setTicketAction(null);
    handleClose();
  };

  return (
    <>
      <Modal show={show} onHide={handleCloseWithReset} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">Ticket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className="row ">
              <div className="col-md-6 mb-3">
                <label htmlFor="taskName" className="visually-hidden">
                  Task Name*
                </label>
                <input
                  type="text"
                  className="form-control "
                  id="taskName"
                  placeholder="Task Name*"
                  {...register("taskName", { required: true })}
                />
                {errors.taskName && (
                  <span className="text-danger">Task Name is required</span>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="date" className="visually-hidden">
                  Date*
                </label>
                <input
                  type="date"
                  className="form-control "
                  id="date"
                  placeholder="Date*"
                  {...register("date", { required: true })}
                />
                {errors.date && (
                  <span className="text-danger">Date is required</span>
                )}
              </div>
              <div className="col-md-3 mb-3">
                <label htmlFor="time" className="visually-hidden">
                  Time*
                </label>
                <input
                  type="time"
                  className="form-control "
                  id="time"
                  placeholder="Time*"
                  {...register("time", { required: true })}
                />
                {errors.time && (
                  <span className="text-danger">Time is required</span>
                )}
              </div>
            </div>

            <div className="row ">
              <div className="col-md-12 mb-3">
                <textarea
                  className="form-control"
                  id="purpose"
                  placeholder="Purpose*"
                  rows="3"
                  {...register("purpose", { required: true })}
                />
                {errors.purpose && (
                  <span className="text-danger">Purpose is required</span>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <Select
                    id="customer"
                    name="customer"
                    placeholder={labels.customerName}
                    required
                    options={customerOptions}
                    value={selectedCustomer}
                    onChange={handleCustomerChange}
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: "40px",
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        justifyContent: "flex-start",
                      }),
                      menu: (base) => ({
                        ...base,
                        zIndex: 100,

                        marginTop: "5px",
                      }),
                      option: (base, { isFocused }) => ({
                        ...base,
                        textAlign: "left",
                        padding: "10px 15px",
                      }),
                    }}
                  />
                  {errors.customer && (
                    <p className="text-danger">{errors.customer.message}</p>
                  )}
                </div>
              </div>

              {subCustomers[selectedCustomer?.value]?.length > 0 && (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <Select
                      id="subCustomer"
                      name="subCustomer"
                      placeholder={labels.subCustomerName}
                      options={subcustomerOptions}
                      value={selectedSubCustomer}
                      onChange={handleSubCustomerChange}
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: "40px",
                        }),
                        valueContainer: (base) => ({
                          ...base,
                          justifyContent: "flex-start",
                        }),
                        menu: (base) => ({
                          ...base,
                          zIndex: 100,
                          // maxHeight: "200px",
                          // overflowY: "auto",
                          marginTop: "5px",
                        }),
                        option: (base, { isFocused }) => ({
                          ...base,
                          textAlign: "left",
                          padding: "10px 15px",
                        }),
                      }}
                      isClearable
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                    {errors.subCustomer && (
                      <span className="text-danger">Name is required</span>
                    )}
                  </div>
                </div>
              )}

              {brandNames[selectedCustomer?.value]?.length > 0 &&
                !hiddenFields.includes("product_name") && (
                  <div className="col-md-4 mb-3">
                    <div className="form-group">
                      <Select
                        id="product_name"
                        name="product_name"
                        placeholder="Product Name"
                        options={(
                          brandNames[selectedCustomer?.value] || []
                        ).map((brandName) => ({
                          value: brandName.id,
                          label: brandName.name || "None",
                        }))}
                        value={selectedBrandName}
                        onChange={handleBrandNameChange}
                        isClearable
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "40px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            justifyContent: "flex-start",
                          }),
                          menu: (base) => ({
                            ...base,
                            zIndex: 100,
                            marginTop: "5px",
                          }),
                          option: (base, { isFocused }) => ({
                            ...base,
                            textAlign: "left",
                            padding: "10px 15px",
                          }),
                        }}
                      />

                      {errors.product_name && (
                        <span className="text-danger">
                          Product Name is required
                        </span>
                      )}
                    </div>
                  </div>
                )}

              {!hiddenFields.includes("model") && (
                <div className="col-md-4 mb-3">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      id="model"
                      placeholder="Model No"
                      {...register("model")}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="row ">
              <div className="col mb-3">
                <label htmlFor="service" className="visually-hidden">
                  Service *
                </label>
                <Select
                  options={serviceOptions}
                  value={selectedService}
                  onChange={handleServiceChange}
                  placeholder="Select a Service"
                  required
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: "40px",
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      justifyContent: "flex-start",
                    }),
                    menu: (base) => ({
                      ...base,
                      zIndex: 100,
                      marginTop: "5px",
                    }),
                    option: (base, { isFocused }) => ({
                      ...base,
                      textAlign: "left",
                      padding: "10px 15px",
                    }),
                  }}
                />
              </div>
            </div>

            <div className="text-end">
              <Button
                variant="secondary"
                className="mx-2"
                onClick={handleClose}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="mx-2"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </>
                ) : action === "edit" ? (
                  "Submit"
                ) : action === "reassign" ? (
                  "Reassign Ticket"
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>

      <AddTagModal
        show={showAddTagModal}
        handleClose={() => setShowAddTagModal(false)}
        fetchCustomers={fetchCustomers}
        selectedCustomer={user}
        fetchSubCustomers={fetchSubCustomersTec}
      />
    </>
  );
}

export default GenerateTicketsModal;
